/* eslint-disable @typescript-eslint/ban-ts-comment */
// @ts-nocheck
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import React from 'react'
import {
    Select,
    SelectContent,
    SelectGroup,
    SelectItem,
    SelectLabel,
    SelectTrigger,
    SelectValue,
  } from "@/components/ui/select"
import Alert from '../common/Alert'
import { Button } from '@/components/ui/button'
import { makeRequest } from '@/utils/axiosInterceptor'
import { useQueryClient } from "@tanstack/react-query";
import { useGetFetchQuery } from '@/hooks/query-client'
import { Switch } from "@/components/ui/switch"
import { toast } from 'sonner'

const defaultUserData = {
    name: '',
    user_group: '',
    email: '',
    username: '',
    password: '',
    hospital_clinic_id: '',
    designation: '',
    mfa_enabled: false,
    pii_allowed: false
}

export default function UserCreateForm({setAddUserSheet}) {
    const queryClient = useQueryClient();
 
     const [userData, setUserData] = React.useState(defaultUserData)
     const hospitalData = useGetFetchQuery(['hospital'])
     const [rentered, setRenetered] = React.useState('')

 
 
 
     const createUser = async () => {
         try {
             console.log('creating')
             console.log(userData)

             if(userData.password !== rentered) {
                toast.error('Passwords do not match')
                return
             }
              if(userData.hospital_clinic_id === '') {
                  toast.error('Please select a hospital')
                  return
              }
              if(userData.name === '') {
                  toast.error('Please enter a name')
                  return
              }
              if(userData.user_group === '') {
                  toast.error('Please select a user group')
                  return
              }
              if(userData.username === '') {
                  toast.error('Please enter a username')
                  return  
              }
              if(userData.password === '') {
                  toast.error('Please enter a password')
                  return
              }
              // if(userData.designation === '') {
              //     toast.error('Please enter a designation')
              //     return
              // }
              if(userData.email === '') {
                  toast.error('Please enter an email')
                  return
              }
              if(userData.mfa_enabled === '') {
                  toast.error('Please select if MFA is enabled')
                  return
              }
              if(userData.pii_allowed === '') {
                  toast.error('Please select if PII is allowed')
                  return
              }
              const res = await makeRequest('POST', '/users/create', userData)
              console.log(res)

              if (res?.statusCode && res?.statusCode >= 400) {
                  toast.error(res?.message || 'Failed to create user')
                  setActivateAlert(false)
                  return
              }
              if (res?.status === 201) {
                  setActivateAlert(false)
                  queryClient.invalidateQueries({
                      queryKey: ["User"],
                  });
                  setUserData(defaultUserData)
                  setAddUserSheet(false)
              }
              
            //  const res = await makeRequest('POST', '/hospitals/create', userData) 
            //  console.log(res)
            //  if (res?.status === 201) {
            //      setActivateAlert(false)
            //      queryClient.invalidateQueries({
            //          queryKey: ["hospital"],
            //      });
            //      setUserData(defaultUserData)
            //      setAddHospitalSheet(false)
            //  }
         } catch (error) {
             console.log(error)
         }
     }
 
     const [activateAlert, setActivateAlert] = React.useState(false)
   return (
     <div>
          <div className="grid gap-4 py-4">
            <div className="grid grid-cols-4 items-center gap-4">
                <Label htmlFor="name" className="text-right">
                    Associated Hospital
                </Label>
                <Select 
                    onValueChange={(value) => setUserData({...userData, hospital_clinic_id: value})} 
                    value={userData.hospital_clinic_id}
                >
                    <SelectTrigger className="col-span-3">
                        <SelectValue placeholder="Hospital" />
                    </SelectTrigger>
                    <SelectContent>
                        <SelectGroup>
                        <SelectLabel>Institution Type</SelectLabel>
                        {
                            hospitalData !== undefined ? hospitalData.map((item) => {
                                return (
                                    <SelectItem value={item.id}>{item.name}</SelectItem>
                                )
                            })
                            :
                            null
                        }
                        </SelectGroup>
                    </SelectContent>
                </Select>
            </div>
           <div className="grid grid-cols-4 items-center gap-4">
             <Label htmlFor="name" className="text-right">
               Name
             </Label>
             <Input 
                 placeholder='Name of user'
                 value={userData.name} onChange={(e) => setUserData({...userData, name: e.target.value})} 
                 id="name" 
                 className="col-span-3" 
             />
           </div>
           <div className="grid grid-cols-4 items-center gap-4">
             <Label  className="text-right">
               User Group
             </Label>
             <Select 
                 
                 onValueChange={(value) => setUserData({...userData, user_group: value})} 
             >
                 <SelectTrigger className="col-span-3">
                     <SelectValue placeholder="Select User Group" />
                 </SelectTrigger>
                 <SelectContent>
                     <SelectGroup>
                     <SelectLabel>User Group</SelectLabel>
                     <SelectItem value="Root">Root</SelectItem>
                     <SelectItem value="Admin">Admin</SelectItem>
                     <SelectItem value="Self">Self</SelectItem>
                     <SelectItem value="AllStudy">All Study</SelectItem>
                     <SelectItem value="Reporter">Reporter</SelectItem>
                     <SelectItem value="AiEvaluator">AiEvaluator</SelectItem>
                     </SelectGroup>
                 </SelectContent>
             </Select>
           </div>
           <div className="grid grid-cols-4 items-center gap-4">
             <Label htmlFor="name" className="text-right">
               Username (Used for Login)
             </Label>
             <Input 
                 placeholder='@username'
                 value={userData.username} onChange={(e) => setUserData({...userData, username: e.target.value})} 
                 id="username" 
                 className="col-span-3" 
             />
           </div>
           <div className="grid grid-cols-4 items-center gap-4">
             <Label htmlFor="password" className="text-right">
               Password
             </Label>
             <Input 
                 placeholder='Password'
                 value={userData.password} onChange={(e) => setUserData({...userData, password: e.target.value})} 
                 id="username" 
                 className="col-span-3" 
                 type='password'
             />
           </div>
           <div className="grid grid-cols-4 items-center gap-4">
             <Label htmlFor="password" className="text-right">
               Re-enter Password
             </Label>
             <Input 
                 value={rentered}
                 onChange={(e) => setRenetered(e.target.value)}
                 placeholder='Confirm Password'
                 id="username" 
                 className="col-span-3" 
                 type='password'
             />
           </div>
           <div className="grid grid-cols-4 items-center gap-4">
             <Label htmlFor="designation" className="text-right">
               Designation
             </Label>
             <Input 
                 id="designation" 
                 value={userData.designation} 
                 onChange={(e) => setUserData({...userData, designation: e.target.value})}  
                 className="col-span-3" 
                 placeholder='Designation of user'
             />
           </div>
           <div className="grid grid-cols-4 items-center gap-4">
             <Label htmlFor="email" className="text-right">
               Email
             </Label>
             <Input 
                 id="email" 
                 value={userData.email}
                 className="col-span-3" 
                 onChange={(e) => setUserData({...userData, email: e.target.value})}
                 placeholder='hospital@abc.com'
             />
           </div>
           <div className="grid grid-cols-4 items-center gap-4">
                <Label className="text-right" htmlFor="airplane-mode">MFA Enabled</Label>
                <div>
                    <Switch 
                        checked={userData.mfa_enabled} 
                        onCheckedChange={(value) => setUserData({...userData, mfa_enabled: value})}  
                        id="airplane-mode" 
                        className="col-span-3"
                    />
                </div>
           </div>
           <div className="grid grid-cols-4 items-center gap-4">
                <Label className="text-right" htmlFor="airplane-mode">PII Allowed</Label>
                <div>
                    <Switch 
                        checked={userData.pii_allowed} 
                        onCheckedChange={(value) => setUserData({...userData, pii_allowed: value})}  
                        id="airplane-mode" 
                        className="col-span-3" 
                    />
                </div>
           </div>
           {/* <div className="grid grid-cols-4 items-center gap-4">
             <Label htmlFor="contact" className="text-right">
               Contact
             </Label>
             <Input 
                 id="contact" 
                 className="col-span-3" 
                 onChange={(e) => setUserData({...userData, contact: e.target.value})}
                 value={userData.contact}
                 placeholder='1234567890'
             />
           </div> */}
           {/* <div className="grid grid-cols-4 items-center gap-4">
             <Label htmlFor="username" className="text-right">
               Allocated Storage (GB)
             </Label>
             <Input 
                 value={userData.allocated_storage} 
                 onChange={(e) => setUserData({...userData, allocated_storage: parseInt(e.target.value)})}
                 type='number' 
                 className="col-span-3"
             />
           </div>
           <div className="grid grid-cols-4 items-center gap-4">
             <Label htmlFor="username" className="text-right">
               Allowed Users
             </Label>
             <Input 
                 value={userData.allowed_users} 
                 onChange={(e) => setUserData({...userData, allowed_users: parseInt(e.target.value)})}
                 type='number' 
                 className="col-span-3"
             />
           </div>
           <div className="grid grid-cols-4 items-center gap-4">
             <Label htmlFor="username" className="text-right">
               Subscription Active
             </Label>
             <Select 
                 
                 onValueChange={(value) => setUserData({...userData, subscription_active : value === "active" ? true : false})} 
             >
                 <SelectTrigger className="col-span-3">
                     <SelectValue placeholder="Subscription" />
                 </SelectTrigger>
                 <SelectContent>
                     <SelectGroup>
                     <SelectLabel>Activation</SelectLabel>
                     <SelectItem value="active">Active</SelectItem>
                     <SelectItem value="inactive">Inactive</SelectItem>
                     </SelectGroup>
                 </SelectContent>
             </Select>
           </div>
 
           <div className="grid grid-cols-4 items-center gap-4">
             <Label htmlFor="username" className="text-right">
               Subscription Start Date
             </Label>
             <Input 
                 onChange={(e) => setUserData({...userData, subscription_start_date: e.target.value})}
                 value={userData.subscription_start_date}
                 type='datetime-local' className="col-span-3"/>
           </div>
 
           <div className="grid grid-cols-4 items-center gap-4">
             <Label htmlFor="username" className="text-right">
               Subscription End Date
             </Label>
             <Input 
                 value={userData.subscription_end_date}
                 onChange={(e) => setUserData({...userData, subscription_end_date: e.target.value})}
                 type='datetime-local' 
                 className="col-span-3" 
             />
           </div>
  */}
           <div className='flex justify-center mt-[2vh]'>
             <Button onClick={() => setActivateAlert(true)}>Save</Button>
           </div>
         </div>
 
         <Alert
             open={activateAlert}
             setOpen={setActivateAlert}
             title="Create user"
             description ="Are you sure you want to create this new user ?"
             action={createUser}
         />
     </div>
   )
}
